import React from 'react';
import Icon from './Icon';

const SIZES = {
  xs: { fontSize: 12, padding: '5px 10px',  gap: 6,  iconSz: 13 },
  sm: { fontSize: 13, padding: '7px 12px',  gap: 7,  iconSz: 14 },
  md: { fontSize: 14, padding: '9px 16px',  gap: 8,  iconSz: 16 },
  lg: { fontSize: 15, padding: '12px 20px', gap: 10, iconSz: 18 },
};

const KINDS = {
  primary:   { background: 'var(--grad-primary)', color: '#fff',         border: '1px solid transparent' },
  secondary: { background: 'transparent',       color: 'var(--fg)',      border: '1px solid var(--line)' },
  ghost:     { background: 'transparent',       color: 'var(--fg-muted)', border: '1px solid transparent' },
  soft:      { background: 'var(--accent-soft)', color: 'var(--accent)', border: '1px solid transparent' },
  icon:      { background: 'transparent',       color: 'var(--fg-muted)', border: '1px solid transparent', padding: 8 },
};

const Btn = ({ kind = 'primary', size = 'md', icon, iconRight, children, onClick, disabled, style, title, type = 'button' }) => {
  const sz = SIZES[size];
  const kindStyle = KINDS[kind];
  return (
    <button
      type={type}
      onClick={disabled ? undefined : onClick}
      title={title}
      disabled={disabled}
      style={{
        fontFamily: 'var(--font-sans)', fontWeight: 500, letterSpacing: '-0.005em',
        borderRadius: 'var(--r-md)', cursor: disabled ? 'not-allowed' : 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        whiteSpace: 'nowrap', lineHeight: 1, opacity: disabled ? 0.45 : 1,
        transition: 'background 120ms var(--ease-out), transform 80ms var(--ease-out), border-color 120ms',
        gap: sz.gap, fontSize: sz.fontSize, padding: kind === 'icon' ? 8 : sz.padding,
        ...kindStyle, ...style,
      }}
      onMouseEnter={(e) => {
        if (disabled) return;
        if (kind === 'primary') e.currentTarget.style.filter = 'brightness(1.06)';
        if (kind === 'secondary') e.currentTarget.style.borderColor = 'var(--line-bright)';
        if (kind === 'ghost' || kind === 'icon') e.currentTarget.style.background = 'var(--accent-soft)';
        if (kind === 'soft') e.currentTarget.style.background = 'var(--accent-soft-2)';
      }}
      onMouseLeave={(e) => {
        if (kind === 'primary') e.currentTarget.style.filter = 'none';
        if (kind === 'secondary') e.currentTarget.style.borderColor = 'var(--line)';
        if (kind === 'ghost' || kind === 'icon') e.currentTarget.style.background = 'transparent';
        if (kind === 'soft') e.currentTarget.style.background = 'var(--accent-soft)';
        e.currentTarget.style.transform = 'scale(1)';
      }}
      onMouseDown={(e) => { if (!disabled) e.currentTarget.style.transform = 'scale(0.98)'; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      {icon && <Icon name={icon} size={sz.iconSz} />}
      {children}
      {iconRight && <Icon name={iconRight} size={sz.iconSz} />}
    </button>
  );
};

export default Btn;
